import gql from 'graphql-tag';

export const GET_ATT_METRICS_BY_SEGMENT = gql`
  query merchantMetricsBySegment($params: ReportInput!) {
    merchantMetricsBySegment(params: $params) {
      cashbackAmount
      venueType
      sales
      transactions
      aov
      roas
      totalCashbackAmount
      totalCampaignSpend
      minAov
      maxAov
    }
  }
`;

export default GET_ATT_METRICS_BY_SEGMENT;
